<template>
  <div class="app-container" style="height: calc(100vh - 70px);overflow: hidden auto;">
    <el-form
      ref="formDataEdit"
      :model="formData"
      label-position="top"
      size="small"
    >
      <el-card class="box-card mb10">
        <el-descriptions :colon="false" direction="horizontal">
          <!--网点名称 anjun DSP 成本账户可见-->
          <el-descriptions-item v-if="![1,3,5].includes(type)" :label="$t('basicData.siteName') + '：'">
            <span>{{ detailData.name }}</span>
          </el-descriptions-item>
          <!--应付主体-->
          <el-descriptions-item :label="$t('basicData.PayablePrincipal') + '：'">
            <span>{{ detailData.providerBody }}</span>
          </el-descriptions-item>
          <!--应付合计-->
          <el-descriptions-item :label="$t('receivablePayable.TotalAmountToBePaid') + '：'">
            <span>{{ detailData.payableUnsettledAmount }}</span>
          </el-descriptions-item>
          <!-- 已付合计 -->
          <el-descriptions-item :label="$t('receivablePayable.TotalAmountPaid') + '：'">
            <span>{{ detailData.payedAmount }}</span>
          </el-descriptions-item>
          <!-- 未付合计 -->
          <el-descriptions-item :label="$t('receivablePayable.TotalAmountOutstanding') + '：'">
            <span>{{ detailData.unpavedAmount }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </el-card>
      <el-form-item :label="$t('basicData.TradingHours') + '：'" style="margin-top: 20px;">
        <el-date-picker
          v-model="queryDate"
          type="datetimerange"
          size="small"
          :picker-options="pickerOptions"
          :format="dateFormat"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width: 500px"
          :placeholder="$t('basicData.SelectADatetime')"
          @change="getTableDetail()"
        />
        <!--导出账户流水-->
        <el-button
          v-permit:remove="permission"
          type="primary"
          size="mini"
          style="float: right;"
          @click="exportAccountInformation"
        >{{ $t('basicData.ExportAccountRollover') }}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="pending">
      <el-table
        ref="elTable"
        :key="tableKey"
        :data="tableData"
        size="small"
        border
        row-key="idCopy"
        :tree-props="{ children: 'meetSiteBill', hasChildren: true }"
        @header-dragend="headerWidthChange"
      >
        <!--交易日期-->
        <el-table-column
          prop="acceptTime"
          :label="$t('basicData.TradingHours')"
          align="left"
          width="240"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <span>{{ scope.row.acceptTime }}</span>
          </template>
        </el-table-column>

        <!--核付时间-->
        <el-table-column
          v-if="type !== 5"
          prop="acceptOperateTime"
          :label="$t('receivablePayable.TimeOfPayment')"
          align="left"
          width="160"
          :show-overflow-tooltip="true"
        />

        <!--付款单号-->
        <el-table-column
          prop="payableNumber"
          :label="$t('basicData.PaymentSlipNumber')"
          align="left"
          width="240"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <span v-if="scope.row.isParent" class="batchNumber" @click="showDetails(scope.row)">{{ scope.row.payableNumber }}</span>
            <span v-else>{{ scope.row.billBatchNumber }}</span>
          </template>
        </el-table-column>
        <!--交款金额-->
        <el-table-column
          prop="actualFee"
          :label="$t('basicData.PaymentAmount')"
          align="left"
          width="240"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <span>{{ scope.row.actualFee }}</span>
          </template>
        </el-table-column>
        <!--票单金额-->
        <el-table-column
          prop="billFee"
          :label="$t('basicData.TicketAmount'
          )"
          align="left"
          width="240"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <span v-if="scope.row.isParent === true">{{ scope.row.billFee }}</span>
            <span v-else>{{ scope.row.totalReceivable }}</span>
          </template>
        </el-table-column>
        <!--付款账户-->
        <el-table-column
          prop="accountAlias"
          :label="$t('basicData.PaymentAccount')"
          align="left"
          width="240"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <span>{{ scope.row.accountAlias }}</span>
          </template>
        </el-table-column>
        <!--付款方式-->
        <el-table-column
          prop="payableMethod"
          :label="$t('basicData.PaymentMethod')"
          align="center"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div>
              <!--现金-->
              <span v-if="scope.row.payableMethod === 'cash'">{{ $t('basicData.cash') }}</span>
              <!--转账-->
              <span v-if="scope.row.payableMethod === 'transfer'">{{ $t('basicData.transferable') }}</span>
              <!--网络-->
              <span v-if="scope.row.payableMethod === 'network'">{{ $t('basicData.online') }}</span>
              <!--冲销-->
              <span v-if="scope.row.payableMethod === 'sterilisation'">{{ $t('basicData.Elimination') }}</span>
              <!--pix-->
              <span v-if="scope.row.payableMethod === 'pix'">{{ $t('basicData.pix') }}</span>
              <!--其他-->
              <span v-if="scope.row.payableMethod === 'other'">{{ $t('basicData.other') }}</span>
            </div>
          </template>
        </el-table-column>
        <!--附件-->
        <el-table-column
          prop="attachmentUrl"
          :label="$t('basicData.annex')"
          align="center"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div>
              <!--              <el-link-->
              <!--                v-if="scope.row.attachmentUrl" type="success" :href="scope.row.attachmentUrl"-->
              <!--                target="_blank"-->
              <!--              >{{ $t('basicData.View') }}</el-link>-->
              <el-link
                v-if="scope.row.attachmentUrl" type="success" @click="showImg(scope.row.attachmentUrl)"
              >{{ $t('basicData.View') }}</el-link>
            </div>
          </template>
        </el-table-column>
        <!--备注-->
        <el-table-column
          prop="remark"
          :label="$t('receivablePayable.remark')"
          align="left"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div v-if="scope.row.isParent" class="remarkStyle" v-html="scope.row.remark" />
            <div v-else class="remarkStyle" v-html="scope.row.remark" />
          </template>
        </el-table-column>
        <!--创建人-->
        <el-table-column
          prop="createUser"
          :label="$t('basicData.CreatePeople')"
          align="center"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div>{{ scope.row.createUserName }}</div>
          </template>
        </el-table-column>
        <!--创建时间-->
        <el-table-column
          prop="createTime"
          :label="$t('basicData.CreationTime')"
          align="center"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </div>
    <!--付款明细-->
    <el-drawer
      :title="$t('basicData.PaymentDetails')"
      :append-to-body="true"
      :visible.sync="showDetailList"
      direction="ltr"
      size="70%"
    >
      <batch-number-detail
        :key="detailKeyList"
        :batch-number-data="batchNumberData"
        :type="type"
      />
    </el-drawer>

    <FilePreview v-if="imageViewerObj.showViewer" :file-list="imageViewerObj.imgArr" @close="closeViewer" />
  </div>
</template>

<script>
import FilePreview from './filePreview.vue';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiExportOfBillFlow, apiGetDetailPage, apiSiteCostExportOfBillFlow } from '@/api/finance/basicData';
import { getSiteExpenseBillPage } from '@/api/finance/costManagement';
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import dayjs from 'dayjs';

const permissionList = {
  0: 'but:finance:basicData:payable:accountsPayable:edit', // 应付账户
  1: 'but:finance:basicData:payable:hutdispatchAccountsPayable:edit', // 安骏
  2: 'but:finance:basicData:payable:dispatchAccountsPayable:edit', // AJD
  3: 'but:finance:basicData:payable:dspdispatchAccountsPayable:edit', // DSP
  4: 'but:finance:basicData:payable:accountsReceivablePayable:exportAccountStatement', // 应付-揽收账户
  5: 'but:finance:basicData:CostsPayableAccount:FlowOutExport' // 成本账户
};

export default {
  name: 'CheckDetail',
  components: {
    FilePreview,
    'batch-number-detail': () => import('./batchNumberDetail')
  },
  props: {
    // 详情数据
    detailData: {
      type: Object,
      default: () => {
        return {};
      },
      required: true
    },

    // 账户类型 0：应付账户 1：安骏 2：AJD 3：DSP 4：揽收应付 5：成本应付账户
    type: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      queryDate: [this.getAWeek().startDate + ' 00:00:00', this.getAWeek().endDate + ' 23:59:59'],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      choiceDate0: '',
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(
            new Date(choiceDateTime).getDate() - 365
          );
          const maxTime = new Date(choiceDateTime).setDate(
            new Date(choiceDateTime).getDate() + 365
          );
          const min = minTime;
          // const newDate =
          //   new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000;
          const newDate = ((d) => (d.setHours(0, 0, 0, 0), d.setDate(d.getDate() + 1), d.getTime()))(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      tableKey: new Date().getTime(),
      tableData: [],
      total: 0,
      createUser: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          isAccept: 1,
          acceptStartTime: '',
          acceptEndTime: '',
          isSiteDetailsRequest: true
        }
      },
      imageViewerObj: {
        imgArr: [],
        showViewer: false
      },
      showDetailList: false,
      detailKeyList: new Date().getTime(),
      batchNumberData: null,
      formData: {
        id: '',
        settlementType: null,
        settlementAccount: '',
        accountTypeValue: '',
        accountType: ''
      }
    };
  },

  computed: {
    dateFormat() {
      return this.$i18n.locale === 'zh' ? this.zhDate : this.ptDate;
    },
    permission() {
      return permissionList[this.type] || '';
    }
  },

  watch: {
    detailData: {
      immediate: true,
      handler(newVal, oldVal) {
        this.formData.id = newVal.id;
        this.formData.settlementAccount = newVal.settlementAccount;
        this.formData.settlementType = newVal.settlementType;
        this.formData.accountTypeValue = newVal.accountTypeValue;
        this.formData.accountType = newVal.accountType;
      },
      deep: true
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.getTableDetail();
  },
  methods: {
    // 导出
    exportAccountInformation() {
      if (this.type === 5) {
        this.costExportingWaterFlowInfo();
      } else {
        this.exportingWaterFlowInfo();
      }
    },
    // 应付
    exportingWaterFlowInfo() {
      const { id, requestSource, collectionPayableAccountCondition, deliveryPayableAccountCondition, cabinCollectionPayableAccountCondition, accountType } = this.detailData;
      const { queryDate } = this;

      const param = {
        startTime: '',
        endTime: '',
        ids: [id] || undefined,
        accountType: accountType || undefined, // 派送类型 1 AJD 2 DSP
        requestSource: requestSource || undefined, // 派送/揽收应付账户专用字段 1 应付-揽收账户 2 应付-派送账户
        collectionPayableAccountCondition: collectionPayableAccountCondition || undefined, // 揽收应付账户专用字段
        deliveryPayableAccountCondition: deliveryPayableAccountCondition || undefined, // 派送应付账户专用字段
        cabinCollectionPayableAccountCondition: cabinCollectionPayableAccountCondition || undefined, // 安骏应付账户专用字段
        isSiteDetailsRequest: true
      };
      if (queryDate && queryDate.length > 0) {
        param.startTime = queryDate[0];
        param.endTime = queryDate[1];
      }
      apiExportOfBillFlow(param).then(res => {
        if (res.code === 200) {
          return goFinanceExportPage();
        }
      }).then(() => {
        this.$emit('clearDetail');
      }).catch(err => {
        console.error(err);
      });
    },
    // 成本
    costExportingWaterFlowInfo() {
      const { providerName, providerBody, providerId } = this.detailData;
      const { queryDate } = this;
      const param = {
        startTime: '',
        endTime: '',
        costPayableAccountCondition: {
          providerName,
          providerId: providerId || '',
          providerBody
        }
      };
      if (queryDate && queryDate.length > 0) {
        param.startTime = queryDate[0];
        param.endTime = queryDate[1];
      }
      apiSiteCostExportOfBillFlow(param).then(res => {
        if (res.code === 200) {
          return goFinanceExportPage();
        }
      }).then(() => {
        this.$emit('clearDetail');
      }).catch(err => {
        console.error(err);
      });
    },
    // 打开详情
    showDetails(row) {
      this.batchNumberData = row;
      this.showDetailList = true;
      this.detailKeyList = new Date().getTime();
    },
    // 图片点击放大
    showImg(url) {
      this.$set(this.imageViewerObj, 'showViewer', true);
      this.$set(this.imageViewerObj, 'imgArr', url.split(','));
    },
    // 关闭查看图片
    closeViewer() {
      this.$set(this.imageViewerObj, 'showViewer', false);
    },
    // 默认最近一年时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(365, 'day').format('YYYY-MM-DD')
      };
    },
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },

    /**
     * 获取查询参数
     * @returns 返回经过处理的查询参数对象
     */
    getQuery() {
      const param = cloneDeep(this.queryForm);
      const { queryDate } = this;

      const {
        siteId,
        requestSource,
        collectionPayableAccountCondition,
        deliveryPayableAccountCondition,
        cabinCollectionPayableAccountCondition,
        costPayableAccountCondition
      } = this.detailData;

      if (this.type !== 1) {
        param.params.siteId = siteId || undefined;
      }

      // 派送/揽收应付账户专用字段
      param.params.requestSource = requestSource || undefined; // 1 揽收 2 派送 3 安骏
      param.params.collectionPayableAccountCondition = collectionPayableAccountCondition || undefined; // 揽收
      param.params.deliveryPayableAccountCondition = deliveryPayableAccountCondition || undefined; // 派送
      param.params.cabinCollectionPayableAccountCondition = cabinCollectionPayableAccountCondition || undefined; // 安骏
      param.params.costPayableAccountCondition = costPayableAccountCondition || undefined; // 成本账户

      // 时间
      if (queryDate && queryDate.length > 1) {
        param.params.acceptStartTime = queryDate[0];
        param.params.acceptEndTime = queryDate[1];
      }

      return param;
    },

    // 查询详情列表
    getTableDetail() {
      const randomString = (e, t) => {
        // e选取字符长度; t字符串
        e = e || 4;
        const a = t.length;
        let n = '';
        for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n;
      };
      function repeat(receiptNumber, random) {
        const randomStr = randomString(4, receiptNumber);
        if (!random.includes(randomStr)) {
          random.push(randomStr);
          return randomStr;
        } else {
          repeat(receiptNumber, random);
        }
      }
      function recurrence(table) {
        const randomArr = [];
        for (let i = 0; i < table.length; i++) {
          const randomId = repeat(table[i].payableNumber.split('-')[1], randomArr);
          if (table[i].acceptTime) {
            table[i].acceptTime = table[i].acceptTime.replace('T', ' ');
          }
          table[i]['idCopy'] = table[i].id + randomId;
          if (table[i].meetSiteBill && table[i].meetSiteBill.length > 0) {
            recurrence(table[i].meetSiteBill);
          }
        }
        return table;
      }

      const param = this.getQuery();
      const fn = this.type === 5 ? getSiteExpenseBillPage : apiGetDetailPage;
      fn(param).then(res => {
        if (res.code === 200) {
          this.tableData = recurrence(res.data.records);
          this.total = res.data.total;
        }
      });
    },
    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getTableDetail();
    },
    // 每页显示数量切换
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getTableDetail();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding:  0 30px;
}
.batchNumber {
  color: #007efd;
  cursor: pointer;
}
</style>
